// VaProd environment configuration
export const environment = {
  production: true,
  name: 'vaprod',
  apiBaseUrl: 'https://api.myfruit.nl/api/',
  signalRUrl: 'https://api.myfruit.nl/hubs/refresh',
  mslConfig: {
    clientId: '8bb8d5fa-c1e0-43f8-8ded-f10248d48ce5',
    authority:
      'https://vanamerongentechnology.ciamlogin.com/9105822c-62e1-47e2-b590-23ed0d476189/',
    redirectUri: 'https://app.myfruit.nl/',
    apiScopes: 'api://9cf9a17b-87db-4718-a460-d3c288d5b912/access_as_user',
  },
  debugWorker: false,
  version: '0.0.40',
};
